import React from 'react';

import {StepTaskGenericChoicesField} from '../generic-choices-fields';

import type {StepTaskFieldProps} from '../commonprops';

export const StepTaskRadiobuttonField = (props: StepTaskFieldProps) => (
  <StepTaskGenericChoicesField inputType="radio" {...props} />
);
